import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import { Link, withRouter } from 'react-router';
import moment from 'moment';
import NumericLabel from 'react-pretty-numbers';
import { monthsObj, displayDateFormat} from '../../../../constants';
import { showCurrencyFormat } from '../../../../utils';
import { checkPermission } from '../../../../utils_v2';
import { Tooltip } from '@material-ui/core';
import { InfoOutlined } from '@material-ui/icons';
import { jetStreamInstance } from '../../../../lease_management/Leases';
class CashFlowList extends Component{
  constructor(props){
    super(props)
  }
  invLink = (cashDetail, id) => {
    if(cashDetail.split(/[\[\]]+/).length > 1){
      let str = cashDetail.split(/[\[\]]+/);
      return (
        <span style={{wordBreak: 'break-word'}}>
          {str[0]}
          { checkPermission('contracts', 'invoices', 'R') ? <Link to={ checkPermission('contracts', 'invoices', 'R') ? `/${this.props.params.type}/${this.props.params.aircraft_slug}/contract/${this.props.params.contract_slug}/invoice/view/${id}`:''}>{str[1]}</Link>:<span>{}</span>}
          {str[2]}
        </span>
      )
    }else{
      return cashDetail;
    }
  }

  render(){
    const { index, cashflow, cashflows } = this.props;
    return(
      <div className="asset-list">
        <Row key={index} className="flex-not-centered cashflow-row">
          <Col md="2" xs="2" className={ index != 0 ? cashflows[index].for_month != cashflows[index-1].for_month ? 'para-ui month-block ' :' ' : 'para-ui month-block' }  >
            {
              index != 0 ? cashflows[index].for_month != cashflows[index - 1].for_month ? monthsObj[cashflow.for_month.slice(4,6)] + ' ' + cashflow.for_month.slice(0,4):'':monthsObj[cashflow.for_month.slice(4,6)] + ' ' + cashflow.for_month.slice(0,4)
            }
            {
              index != 0 ? cashflows[index].for_month != cashflows[index - 1].for_month ?

              <p className="cashflow-monthly-total">
                <span className="cashflow-monthly-total-label">Month Total Cashflow</span>
                {cashflow.monthly_total.length?
                cashflow.monthly_total.map((cashflow, index) =>
                <NumericLabel params={showCurrencyFormat(cashflow.currency)}>{cashflow.total_amount}</NumericLabel> )
                :
                <NumericLabel params={showCurrencyFormat(cashflow.currency)}>0.00</NumericLabel>
                }
              </p>:'':
              <p className="cashflow-monthly-total">
                <span className="cashflow-monthly-total-label">Month Total Cashflow</span>
                {cashflow.monthly_total.length?
                cashflow.monthly_total.map((cashflow, index) =>
                <NumericLabel params={showCurrencyFormat(cashflow.currency)}>{cashflow.total_amount}</NumericLabel> )
                :
                <NumericLabel params={showCurrencyFormat(cashflow.currency)}>0.00</NumericLabel>
                }
              </p>
            }
          </Col>
          <Col md="2" xs="2" className="cash-blk cash-info para-ui border-col">
            {cashflow.name} {(cashflow.rental_invoice_type && jetStreamInstance ? <span style={{fontSize:'12px', fontWeight:'bold', textTransform:'uppercase', fontFamily:'Conv_IBMPlexSans-Medium'}}>({cashflow.rental_invoice_type.label})</span> : '')}
          </Col>
          <Col md="2" xs="2" className="cash-blk cash-info para-ui border-col">
            {cashflow.credit_or_debit ?
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <NumericLabel params={showCurrencyFormat(cashflow.currency)}>
                  {cashflow.amount}
                </NumericLabel>
               {cashflow.excess_amount > 0 ?
                <Tooltip title={`Excess Amount:${cashflow?.currency === 'USD' ? 'US$' : cashflow?.currency === 'EUR' ? '€' : ''}${cashflow.excess_amount}`}>
                  <InfoOutlined style={{color:'#aeacac'}} fontSize="small" />
                </Tooltip>:null}
              </div>
               :
              '--'
            }
          </Col>
          <Col md="2" xs="2" className="cash-blk cash-info para-ui border-col">
            {cashflow.credit_or_debit ? '--':
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <NumericLabel params={showCurrencyFormat(cashflow.currency)}>
                  {cashflow.amount}
                </NumericLabel>
                {cashflow.excess_amount > 0 ?
                <Tooltip title={`Excess Amount:${cashflow?.currency === 'USD' ? 'US$' : cashflow?.currency === 'EUR' ? '€' : ''}${cashflow.excess_amount}`}>
                  <InfoOutlined style={{color:'#aeacac'}} fontSize="small" />
                </Tooltip>:null}
              </div>
            }
          </Col>
          <Col md="2" xs="2" className="cash-blk cash-info para-ui border-col">
            {cashflow.balance ?
              <NumericLabel params={showCurrencyFormat(cashflow.currency)}>
                {cashflow.balance}
              </NumericLabel>
               :
              '--'
            }
          </Col>
          <Col md="2" xs="2" className="cash-blk cash-info para-ui border-col">
            { cashflow.transaction_details ? this.invLink(cashflow.transaction_details, cashflow.invoice_id) : '--' }
          </Col>
        </Row>
      </div>
    )
  }
}

export default withRouter(CashFlowList);
